import { Component, Input } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
import { ResourceAssignment } from '../../shared/entities/resourceAssignment/resourceAssignment';
import { TaskView } from '../task-detail-view/task-detail-view.component';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-nexcore-operated-rental-task-view',
  templateUrl: './nexcore-operated-rental-task-view.component.html',
  styleUrls: ['./nexcore-operated-rental-task-view.component.scss']
})
export class NexcoreOperatedRentaltTaskViewComponent implements TaskView  {

  resourceAssignents: ResourceAssignment[];

  _task: Task;
  @Input() set task(task: Task) {
    if(task) {
      this.loadTask(task.id);
    }
  }

  constructor(
    private apollo: Apollo
  ) {

  }

  loadTask(id: string) {
    if(id) {
      this.apollo.query<fromGraphQl.OperatedRentalQuery>({
        query: fromGraphQl.OPERATED_RENTAL_TASK_QUERY,
        variables: {
          id: id
        },
        fetchPolicy: 'network-only',
      })
      .pipe(take(1))
      .subscribe( result => {
        this._task = new Task(result?.data?.task);
      })
    }
  }
  
  getHeadline(): string {
    return this._task?.protocol?.formControlTemplate?.settings?.label;
  }
  
}
